import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Vehicle damages stats DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_DAMAGE)
export class VehicleDamagesStatsDto extends BaseStatsDto {
	pending!: number;
	approved!: number;
	rejected!: number;
	estimated!: number;
	repaired!: number;
	ignored!: number;
}
